import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core'
import { InfiniteScrollDirective } from 'ngx-infinite-scroll'
import { InfiniteScrollContainer } from '../../interfaces/infinite-scroll-container.interface'

@Component({
  selector: 'wm-front-infinite-scroll-container',
  templateUrl: './infinite-scroll-container.component.html',
  styleUrls: ['./infinite-scroll-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [InfiniteScrollDirective],
})
export class InfiniteScrollContainerComponent implements OnInit {
  /** Params for override default options */
  @Input() public overridedOptions: Partial<InfiniteScrollContainer> = {}

  /** Event dispatched when the distance to the bottom is reached */
  @Output() public scrolled: EventEmitter<null> = new EventEmitter()

  /** Event dispatched when the distance to the top is reached */
  @Output() public scrolledUp: EventEmitter<null> = new EventEmitter()

  /** Default params for infinite scroll */
  public options: InfiniteScrollContainer = {
    downDistance: 2,
    upDistance: 1.5,
    throttle: 150,
    disable: false,
    scrollWindow: true,
    immediateCheck: false,
    horizontal: false,
    alwaysCallback: false,
    fromRoot: false,
    infiniteScrollContainer: null,
  }

  public ngOnInit(): void {
    this.options = Object.assign(this.options, this.overridedOptions)
  }

  /** Emit the scrolled event to the parent componement */
  public onScroll(): void {
    this.scrolled.emit()
  }

  /** Emit the scrolledUp event to the parent componement */
  public onScrollUp(): void {
    this.scrolledUp.emit()
  }
}
